import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { setIsLoading as setIsLoadingAction } from './actions';
import { store } from './store';

export function useAppContext() 
{
	const context = React.useContext(store);
	const navigate = useNavigate();

	if (context === undefined)
		throw new Error('useAppContext must be used within an AppContextProvider');

	const setIsLoading = (isLoading: boolean) =>
		context.dispatch(setIsLoadingAction(isLoading));

	const navigateToAssessmentPage = (assessmentId: string, pageIndex:number) =>
		navigateTo(`/assessment/${encodeURIComponent(assessmentId)}/page/${encodeURIComponent(pageIndex)}`);

	const navigateToAssessmentCompletePage = () =>
		navigateTo('/assessment/completed/success');

	const navigateTo = (path: string) => 
	{
		console.log('Navigating to', path);
		navigate(path);
	}

	return {
		isLoading: context.state.isLoading,
		navigateToAssessmentPage,
		navigateToAssessmentCompletePage,
		setIsLoading
	} as const;
}
